import { render, staticRenderFns } from "./cards-dashboard.vue?vue&type=template&id=2bf73bec"
import script from "./cards-dashboard.vue?vue&type=script&lang=js"
export * from "./cards-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports